<div #wrapper id="wrapper" infiniteScroll
     [infiniteScrollDistance]="1"
     [infiniteScrollThrottle]="50"
     [infiniteScrollContainer]="wrapper"
     (scrolled)="onScroll()">
  <app-loading #loadingComponent></app-loading>
  <app-error #errorComponent [msg]="'Algo no funciona :('"></app-error>
  <app-front-post (deleted)="postDeleted($event)" *ngFor="let post of posts" [post]="post"></app-front-post>
</div>
